import SimpleText from "@/components/texts/simpleText";
import Link from "next/link";
import themes from "@/styles/themes";

import {useSelector} from "react-redux";
import Events from "@/utils/Events";
import { GET_OFFER_TYPE } from "../../store/slices/offerSlice";

type ContratoAssinaturaType = {
    paymentMethod?: '' | 'cartao' | 'debito' | 'paypal' | 'voucher' | 'cortesia'
}

export default function ContratoAssinatura({ paymentMethod = '' }: ContratoAssinaturaType) {
    const offer_type = useSelector(GET_OFFER_TYPE)
    const events = new Events();
    return (
        <div className={'text--center'}>
            <SimpleText color={themes.greyDark} linkColor={themes.estadao}>
                Ao clicar em pagar você estará concordando com o  <br/>
                <Link style={{textDecoration: 'underline'}} href={"https://assets.estadao.com.br/checkout/condicoes-gerais-contratacao-assinaturas-estadao-09-06-26.pdf"} target={'_blank'}
                    onClick={()=>{
                        events.trigger("pagamento_contrato_de_assinatura", { paymentMethod, offer_type })
                    }}>Contrato de Assinatura do Estadão</Link>
            </SimpleText>
        </div>
    )
}